import { Tabs } from 'antd';
import { Outlet, useLocation, useNavigate } from 'react-router';
import tw from 'twin.macro';

import { PATH } from '@/Route';

const MarketingProductManageIndex = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div>
      <Tabs
        activeKey={location.pathname}
        items={[
          {
            key: PATH.MARKETING_PRODUCT_MANAGE.INDEX,
            label: '상품 관리',
          },
          {
            key: PATH.MARKETING_PRODUCT_MANAGE.ORDER,
            label: '신청 관리',
          },
        ]}
        onChange={(value) => navigate(value)}
      />

      <div css={tw`mt-[16px] w-full`}>
        <Outlet />
      </div>
    </div>
  );
};

export default MarketingProductManageIndex;
